module.exports = __webpack_public_path__ + "media/images/flags/16/Belize-06f78333ec835b8020ebb5a283ed8b08.png";